import { Navigation } from '@src/routing/Navigation';
import { useSearchParams } from 'react-router-dom';

export const useCurrentOrder = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const orderId =
    searchParams.get(Navigation.orderDetails.searchParamKey) ?? undefined;

  const setCurrentOrder = (orderId: string) => {
    searchParams.set(Navigation.orderDetails.searchParamKey, orderId);
    setSearchParams(searchParams);
  };

  const removeCurrentOrder = () => {
    searchParams.delete(Navigation.orderDetails.searchParamKey);
    searchParams.delete(Navigation.orderMode.searchParamKey);
    searchParams.delete(Navigation.permit.searchParamKey);
    setSearchParams(searchParams);
  };

  return {
    orderId,
    setCurrentOrder,
    removeCurrentOrder,
  };
};
